<template>
  <div class="sub-infos">
    <template v-for="(item, index) in digitalFlopData">
      <div class="sub-infos-content" :key="index">
        <div class="sub-infos-content-card" v-for="(m, n) in item" :key="n">
          <div class="sub-infos-content-card-title">{{m.title}}</div>
          <dv-digital-flop :config="m.number" class="sub-infos-content-card-num" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { getBasicDataApi } from '@/api/school'
export default {
  name: 'SubInfos',
  props: {
    schoolId: Number
  },
  data () {
    return {
      digitalFlopData: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      getBasicDataApi({ schoolId: this.schoolId }).then(res => {
        this.digitalFlopData = [
          [
            {
              title: '注册学员',
              number: {
                number: [res.result.registerCount],
                content: '{nt}人',
                textAlign: 'center',
                style: {
                  fill: '#f46827',
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              },
            },
            {
              title: '报名学员',
              number: {
                number: [res.result.studentCount],
                content: '{nt}人',
                textAlign: 'center',
                style: {
                  fill: '#f46827',
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              },
            }
          ],
          [
            {
              title: '报名次数',
              number: {
                number: [res.result.signCount],
                content: '{nt}次',
                textAlign: 'center',
                style: {
                  fill: '#f46827',
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              },
            },
            {
              title: '课程数量',
              number: {
                number: [res.result.courseCount],
                content: '{nt}个',
                textAlign: 'center',
                style: {
                  fill: '#f46827',
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              },
            }
          ]
        ]
        setTimeout(this.getData, 10000)
      })
    }
  },
}
</script>

<style lang="less">
.sub-infos {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;

    .sub-infos-content {
      width: 100%;
      height: 100%;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-evenly;

      .sub-infos-content-card {
        background-color: rgba(35, 36, 134, 0.459);
        border-radius: 5px;
        width: 45%;
        height: 100%;

        .sub-infos-content-card-title {
          height: 20px;
          line-height: 20px;
          margin-top: 10px;
          text-align: center;
          font-weight: bold;
        }

        .sub-infos-content-card-num {
          width:100%;
          height:40px;
        }
      }
    }
}
</style>
